(function (window, document) {
  'use strict';

  var WIDGET_SELECTOR = '[data-gc-inquiry-list]';

  // Fallback used when the widget does not provide localized range labels.
  var DEFAULT_RANGE_OPTIONS = [
    { value: '1-9', label: '1 – 9' },
    { value: '10-49', label: '10 – 49' },
    { value: '50-99', label: '50 – 99' },
    { value: '100+', label: '100 und mehr' }
  ];

  var EXTERNAL_LINK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="gc-inquiry-list__shop-hint-icon"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';

  function getContainers() {
    return Array.prototype.slice.call(document.querySelectorAll(WIDGET_SELECTOR));
  }

  /**
   * Read the localized range options from the widget container.
   * @param {HTMLElement} container
   * @returns {Array<{value:string,label:string}>}
   */
  function getRangeOptions(container) {
    var raw = container.getAttribute('data-quantity-options');
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) {
          return parsed.filter(function (opt) {
            return opt && opt.value;
          });
        }
      } catch (e) {
        // Fall through to defaults on malformed JSON.
      }
    }
    return DEFAULT_RANGE_OPTIONS;
  }

  /**
   * Whether the shop hint should be shown for the given range.
   * The hint targets small quantities (non-bulk ranges, e.g. 1-9).
   * @param {string} range
   * @returns {boolean}
   */
  function shouldShowShopHint(range) {
    if (!range) {
      return false;
    }
    if (window.GCInquiry && typeof window.GCInquiry.isBulkRange === 'function') {
      return !window.GCInquiry.isBulkRange(range);
    }
    return false;
  }

  function buildItem(product, container, index) {
    var li = document.createElement('li');
    li.className = 'gc-inquiry-list__item';
    li.setAttribute('data-product-id', product.id);

    var inner = document.createElement('div');
    inner.className = 'gc-inquiry-list__item-inner';

    var thumb = document.createElement('div');
    thumb.className = 'gc-inquiry-list__thumb';
    if (product.image) {
      var img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title || '';
      thumb.appendChild(img);
    } else {
      var placeholder = document.createElement('div');
      placeholder.className = 'gc-inquiry-list__thumb-placeholder';
      var placeholderImg = (window.gcpOverlayI18n || {}).placeholderImg;
      if (placeholderImg) {
        var pImg = document.createElement('img');
        pImg.src = placeholderImg;
        pImg.alt = '';
        pImg.setAttribute('aria-hidden', 'true');
        placeholder.appendChild(pImg);
      }
      thumb.appendChild(placeholder);
    }

    var meta = document.createElement('div');
    meta.className = 'gc-inquiry-list__meta';
    if (product.url) {
      var link = document.createElement('a');
      link.className = 'gc-inquiry-list__title';
      link.href = product.url;
      link.textContent = product.title || '';
      meta.appendChild(link);
    } else {
      var title = document.createElement('span');
      title.className = 'gc-inquiry-list__title';
      title.textContent = product.title || '';
      meta.appendChild(title);
    }

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'gc-inquiry-list__remove';
    removeBtn.setAttribute('data-product-id', product.id);
    var removeLabel = container.getAttribute('data-remove-label') || (window.gcpOverlayI18n || {}).remove || 'Entfernen';
    removeBtn.setAttribute('aria-label', removeLabel + ': ' + (product.title || ''));
    removeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';

    // Right column: title + remove on top, then quantity select and shop hint
    var content = document.createElement('div');
    content.className = 'gc-inquiry-list__content';

    var head = document.createElement('div');
    head.className = 'gc-inquiry-list__head';
    head.appendChild(meta);
    head.appendChild(removeBtn);

    // Quantity row: label + range select
    var quantityWrap = document.createElement('div');
    quantityWrap.className = 'gc-inquiry-list__quantity';
    var quantityId = 'gc-inquiry-qty-' + product.id + '-' + index;

    var quantityLabel = document.createElement('label');
    quantityLabel.className = 'gc-inquiry-list__quantity-label';
    quantityLabel.setAttribute('for', quantityId);
    quantityLabel.textContent = container.getAttribute('data-quantity-label') || 'Ungefähre Stückzahl';

    var select = document.createElement('select');
    select.className = 'gc-inquiry-list__quantity-select';
    select.id = quantityId;
    select.setAttribute('data-gc-inquiry-qty', 'true');
    select.setAttribute('data-product-id', product.id);

    var placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = container.getAttribute('data-quantity-placeholder') || '– bitte wählen –';
    if (!product.range) {
      placeholderOption.selected = true;
    }
    select.appendChild(placeholderOption);

    getRangeOptions(container).forEach(function (opt) {
      var option = document.createElement('option');
      option.value = opt.value;
      option.textContent = opt.label;
      if (opt.value === product.range) {
        option.selected = true;
      }
      select.appendChild(option);
    });

    quantityWrap.appendChild(quantityLabel);
    quantityWrap.appendChild(select);

    // Shop hint: shown for small quantities (non-bulk ranges)
    var shopHint = document.createElement('div');
    shopHint.className = 'gc-inquiry-list__shop-hint';
    var hintLink = document.createElement('a');
    hintLink.className = 'gc-inquiry-list__shop-hint-link';
    hintLink.href = product.shopUrl || product.url || '#';
    hintLink.target = '_blank';
    hintLink.rel = 'noopener noreferrer';
    var hintText = document.createElement('span');
    hintText.className = 'gc-inquiry-list__shop-hint-text';
    hintText.textContent = container.getAttribute('data-shop-hint') || '1–9 Geräte? Direkt im Gastro-Cool Shop bestellen';
    hintLink.appendChild(hintText);
    hintLink.insertAdjacentHTML('beforeend', EXTERNAL_LINK_SVG);
    shopHint.appendChild(hintLink);
    if (!shouldShowShopHint(product.range)) {
      shopHint.hidden = true;
    }

    content.appendChild(head);
    content.appendChild(quantityWrap);
    content.appendChild(shopHint);

    inner.appendChild(thumb);
    inner.appendChild(content);
    li.appendChild(inner);

    return li;
  }

  function renderContainer(container) {
    if (!window.GCInquiry || typeof window.GCInquiry.getInquiryList !== 'function') {
      return;
    }

    var list = window.GCInquiry.getInquiryList();
    var itemsTarget = container.querySelector('[data-gc-inquiry-items]');
    var emptyEl = container.querySelector('[data-gc-inquiry-empty]');
    var headingEl = container.querySelector('[data-gc-inquiry-heading]');

    if (!itemsTarget) {
      return;
    }

    itemsTarget.innerHTML = '';

    var headingText = container.getAttribute('data-heading-text') || '';
    if (headingEl && headingText) {
      headingEl.textContent = headingText;
    }
    if (emptyEl) {
      var emptyText = container.getAttribute('data-empty-text') || emptyEl.textContent;
      emptyEl.textContent = emptyText;
    }

    if (Array.isArray(list) && list.length > 0) {
      list.forEach(function (product, index) {
        itemsTarget.appendChild(buildItem(product, container, index));
      });
      container.classList.add('gc-inquiry-list--has-items');
      container.classList.remove('gc-inquiry-list--empty');
    } else {
      container.classList.add('gc-inquiry-list--empty');
      container.classList.remove('gc-inquiry-list--has-items');
    }
  }

  function refreshAll() {
    getContainers().forEach(renderContainer);
  }

  function bindContainer(container) {
    if (container.__gcInquiryListBound) {
      return;
    }
    container.__gcInquiryListBound = true;

    container.addEventListener('click', function (event) {
      var target = event.target;
      if (!target) {
        return;
      }
      var removeBtn = target.closest ? target.closest('.gc-inquiry-list__remove') : null;
      if (removeBtn && container.contains(removeBtn)) {
        event.preventDefault();
        var productId = removeBtn.getAttribute('data-product-id');
        if (productId && window.GCInquiry && typeof window.GCInquiry.removeFromInquiry === 'function') {
          window.GCInquiry.removeFromInquiry(productId);
          renderContainer(container);
        }
      }
    });

    var handleRangeChange = function (event) {
      var select = event.target;
      if (!select || select.getAttribute('data-gc-inquiry-qty') !== 'true') {
        return;
      }
      var productId = select.getAttribute('data-product-id');

      if (productId && window.GCInquiry && typeof window.GCInquiry.updateRange === 'function') {
        // Triggers an "inquiryListChanged" event which re-renders the list
        // (and toggles the shop hint based on the new range).
        window.GCInquiry.updateRange(productId, select.value);
      }
    };

    container.addEventListener('change', handleRangeChange);
  }

  function init() {
    var containers = getContainers();
    containers.forEach(function (container) {
      bindContainer(container);
    });
    refreshAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('inquiryListChanged', refreshAll);
})(window, document);
